<gl-button color-primary [text]="'settings.clients.activationWidget.button' | translate" (onClick)="open()"></gl-button>
<lms-modal #activationTableModal size="large" (paste)="onPaste($event)">
  <div class="gl-popup__close" (click)="close()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__title margin-bottom">{{ 'settings.clients.activationWidget.tableTitle' | translate }}</div>
  <p class="margin-bottom">{{ 'settings.clients.activationWidget.tableMessage' | translate }}</p>

  <ng-container *ngIf="dataSource">
    <gl-table-header [columns]="dataSource.columns"></gl-table-header>
    <div class="activation-table">
      <gl-table id="clientsActivationWidgetListId" [dataSource]="dataSource" data-testid="clientsActivationWidgetTable">
        <span slot="header"></span>
        <div class="placeholder" slot="placeholder"></div>
      </gl-table>
    </div>
  </ng-container>

  <gl-button
    color-tertiary
    icon-left="glicon-plus-circle"
    [text]="'settings.clients.activationWidget.addRow' | translate"
    (onClick)="createEmptyRow()"
  ></gl-button>

  <div class="gl-popup__buttons position-static padding-top__big">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="close()"> </gl-button>
    <gl-button
      color-primary
      [disabled]="saveDisabled"
      [text]="'actions.save' | translate"
      (onClick)="save()"
    ></gl-button>
  </div>
</lms-modal>
